import { resourcesParams } from "./resources.params"
import _ from "lodash"

const baseMessages = {
    internal: {
        actions: "Actions",
        errors: {
            "Error on parse data": "Error parsing data",
        },
        list: "List",
        tree: "Tree",
        audit: "Audit",
        edit: "Edit",
        show: "Show",
        success: "Success",
        error: "Error",
        cancel: "Cancel",
        confirm: "Confirm",
        settings: "Settings",
        create: "Create",
        resetZoom: "Reset zoom",
        fullscreen: "Fullscreen",
        daterange: "Date range",
        current_data: "Current data",
        online: "Online mode",
        historical_data: "Historical data",
        company_resource: "Resouce supplier company",
        company_customer: "Customer",
        company_service: "Service company",
        coordinate_picker: {
            select_on_map: "Select on the map",
            title: "Select Coordinates on the Map",
            hint: "Click on the map to select coordinates or enter them manually",
            latitude: "Latitude",
            longitude: "Longitude",
            selected: "Selected Coordinates",
        },
    },
    menu: {
        reference_books: "Reference Books",
        drivers_params: "Drivers and params",
    },
    dashboard: {
        welcome: {
            title: "Dashboard",
            subtitle: "Real-time system overview",
        },
        stats: {
            objects: "Objects",
            devices: "Devices",
            users: "Users",
        },
        error: {
            loading: "Error loading dashboard data",
        },
    },
    resources: {
        audit: {
            field_history: "Field History",
            current_value: "Current Value",
            no_history: "No change history found",
            changes: "Changes",
            action: "Action",
            update: "Update",
            create: "Create",
            was: "Was",
            became: "Became",
            date_time: "Date & Time",
            user: "User",
            loading: "Loading...",
            system: "System",
            deleted: "deleted",
            close: "Close",
            yes: "Yes",
            no: "No",
            table: "Table",
            record_id: "ID"
        },
        units: {
            name: "Units of Measurement",
            values: {
                kpa: "kPa",
                mpa: "MPa",
                pa: "Pa",
                c: "C",
                f: "F",
            },
        },
        common: {
            fields: {
                description: "Description",
                varname: "Code",
                parent_varname: "Parent code",
                created_at: "Created at",
                updated_at: "Updated at",
                timezone: "Timezone",
            },
        },
        users: {
            name: "Users",
            fields: {
                login: "Login",
                name: "Name",
                email: "Email",
                active: "Active",
                roles: "Roles",
                profiles: "Profiles",
                current_profile: "Current profile",
                password: "Password",
                repeat_password: "Repeat Password",
            },
        },
        companies: {
            name: "Companies",
            fields: {
                name: "Full company name",
                short_name: "Short company name",
                parent_id: "Parent company",
                email: "Email",
                timezone: "Timezone",
                type_id: "Company type",
            },
        },
        dashboards: {
            name: "Dashboards",
            fields: {
                name: "Name",
                description: "Description",
                widgets_count: "Widgets count",
                is_public: "Access",
            },
            values: {
                public: "Public",
                private: "Private",
            },
            actions: {
                add_widget: "Add widget",
                add_first_widget: "Add first widget",
                delete_widget: "Delete",
                edit_widget: "Edit",
            },
            messages: {
                loading: "Loading dashboard...",
                error_loading: "Error loading dashboard",
                not_found: "Dashboard not found",
                empty_title: "Dashboard is empty",
                empty_subtitle: "Add widgets to display data",
                delete_confirm_title: "Confirm deletion",
                delete_confirm_message: "Are you sure you want to delete widget \"%{title}\"? This action cannot be undone.",
                cancel: "Cancel",
                delete: "Delete",
                unknown_error: "Unknown error",
                unknown_widget_type: "Unknown widget type: %{type}",
            },
            wizard: {
                title: "Create Dashboard",
                step_template: "Template Selection",
                step_settings: "Dashboard Settings",
                step_confirmation: "Confirmation",
                select_template: "Select dashboard template",
                select_template_hint: "Choose one of the ready-made templates or create an empty dashboard",
                empty_dashboard: "Empty Dashboard",
                empty_dashboard_hint: "Create a dashboard without a template and add widgets yourself",
                widgets_count: "Widgets: %{count}",
                category_empty: "Category: Empty",
                category_label: "Category: %{category}",
                dashboard_settings: "Dashboard Settings",
                dashboard_settings_hint: "Configure basic parameters for your dashboard",
                dashboard_name: "Dashboard Name",
                dashboard_name_hint: "Enter a clear name for your dashboard",
                dashboard_description: "Description",
                dashboard_description_hint: "Describe the purpose and content of the dashboard",
                public_dashboard: "Public Dashboard",
                public_dashboard_hint: "Public dashboards are accessible to all system users",
                confirmation: "Confirm Creation",
                confirmation_hint: "Review settings before creating the dashboard",
                template_label: "Template:",
                name_label: "Name:",
                description_label: "Description:",
                access_label: "Access:",
                back: "Back",
                next: "Next",
                create: "Create Dashboard",
                creating: "Creating...",
            },
            widgets: {
                chart: {
                    name: "Chart",
                    description: "Display data in charts and graphs",
                    type: "Type",
                    data_sources: "Data sources: %{count}",
                    no_data_source: "No data source configured",
                    no_data: "No data to display",
                    configure_data_source: "Add a data source in widget settings",
                    load_error: "Error loading chart data"
                },
                table: {
                    name: "Table",
                    description: "Tabular data representation",
                    no_data_source: "No data source configured",
                    no_data: "No data to display",
                    error_loading: "Error loading data",
                    search: "Search",
                    showing: "Showing %{from}-%{to} of %{total}"
                },
                gauge: {
                    name: "Gauge",
                    description: "Circular gauges to display indicators",
                    errors: {
                        no_param: "Parameter not selected",
                        load_failed: "Failed to load gauge data"
                    },
                    status: {
                        normal: "Normal",
                        warning: "Warning",
                        critical: "Critical",
                        threshold: "Threshold"
                    }
                },
                text: {
                    name: "Text Block",
                    description: "Display textual information"
                },
                schema: {
                    name: "Schema",
                    description: "Schematic data representation",
                    elements: {
                        tank: "Tank",
                        pump: "Pump",
                        valve: "Valve"
                    },
                    data_sources: "Data Sources",
                    no_data_source: "No data sources to display",
                    error_loading: "Error loading schema data",
                    custom_schema: "Custom Schema",
                    parameters: "Parameters"
                },
                map: {
                    name: "Map",
                    description: "Geographic object display",
                    data_sources: "Data Sources",
                    no_data_source: "No data sources to display",
                    error_loading: "Error loading map data",
                    device: "Device",
                    object: "Object",
                    value: "Value",
                    status: "Status",
                    position: "Position",
                    updated: "Updated"
                }
            },
            widget_wizard: {
                title: "Add Widget",
                step_type: "Type Selection",
                step_settings: "Settings",
                step_confirmation: "Confirmation",
                select_widget_type: "Select Widget Type",
                select_widget_type_hint: "Choose the appropriate widget type to display your data",
                widget_settings: "Widget Settings",
                widget_settings_hint: "Configure basic widget parameters",
                widget_name: "Widget Name",
                widget_name_hint: "Enter a clear name for the widget",
                content: "Content",
                content_hint: "Enter textual content for the widget",
                data_source: "Data Source",
                data_source_hint: "URL or data source identifier",
                chart_type: "Chart Type",
                chart_line: "Line",
                chart_bar: "Bar",
                chart_area: "Area",
                chart_pie: "Pie Chart",
                confirmation: "Confirm Creation",
                confirmation_hint: "Review settings before creating the widget",
                size_label: "Widget Size:",
                size_value: "%{width} × %{height} cells",
                back: "Back",
                next: "Next",
                create: "Create Widget",
                creating: "Creating...",
                new_widget_title: "New %{type}",
                default_text_content: "Add your text here",
                min_value: "Minimum Value",
                min_value_hint: "Set the minimum value for the gauge scale",
                max_value: "Maximum Value",
                max_value_hint: "Set the maximum value for the gauge scale",
                unit: "Unit of Measurement",
                unit_hint: "Enter the unit of measurement (e.g., kW, °C, %)",
                gauge_single_param_hint: "Gauge widget displays a single parameter. Select one data source.",
                table_config_coming_soon: "Table configuration is not yet fully implemented.",
                table_config_hint: "You can create the widget, but data source configuration will be available in future updates.",
                select_object: "Select Object",
                select_device: "Select Device",
                select_archive_type: "Select Archive Type",
                select_param: "Select Parameter",
                no_objects: "No objects found",
                no_devices: "No devices found",
                no_archive_types: "No archive types found",
                no_params: "No parameters found",
                object: "Object",
                device: "Device",
                archive_type: "Archive Type",
                param: "Parameter",
            },
        },
        equipments: {
            name: "Equipment",
            fields: {
                name: "Full equipment name",
                label: "Short name",
                equipment_kind_id: "Equipment type",
                equipment_driver_id: "Driver",
                manufacturer_company_id: "Manufacturer",
                energy_kind_id: "Energy resource type",
                sensor_min: "Min sensor value",
                sensor_max: "Max sensor value",
                sensor_unit: "Sensor unit",
            },
        },
        equipmentdrivers: {
            name: "Drivers",
            paramstitle: "Driver params",
            fields: {
                name: "Driver name",
            },
        },
        paramsettings: {
            fields: {
                name: "Name",
                label: "Label",
                data_type: "Type",
                data_column_name: "Column name",
                data_table_name: "Table name",
                decimal_places: "Decimal places count",
                archive_type_id: "Archive type",
                unit_id: "Unit",
            },
        },
        objects: {
            name: "Accounting objects",
            scheme_gts: "GTS scheme",
            map: "GTS on the map",
            fields: {
                name: "Object name",
                object_category_id: "Category",
                object_industry_ids: "Object type / Industry sector",
                address: "Address",
                parent_ids: "Parent objects",
                geoposition: "Geoposition",
                coordinate_picker: {
                    title: "Select coordinates on map",
                    hint: "Click on the map to select coordinates or enter them manually:",
                    latitude: "Latitude",
                    longitude: "Longitude",
                    selected: "Selected coordinates",
                    select_on_map: "Select on map",
                },
            },
        },
        schedules:{
            name: "Schedules",
            create: "Create schedule",
            edit: "Edit schedule",
            fields: {
                date_start: "Start date",
                date_end: "End date",
                crontab: "Schedule value",
                active: "Enabled",
                randomize: "Randomize function",
                description: "Note",
            },
        },
        devices: {
            name: "Devices",
            ddttitle: "DDT",
            chart: "Chart",
            data: "Data",
            ddt: "Press. & Temp. Sensors",
            fields: {
                name: "Name",
                imei: "IMEI",
                phone: "Phone number",
                iccid: "ICCID",
                device_kind_id: "Device type",
                energy_kind_id: "Energy resource type",
                object_id: "Object",
                equipment_ids: "Equipment",
                equipment_id_bbt: "Telemetry",
                equipment_serial_numbers: "Serial number",
                equipment_serial_number_bbt: "Telemetry unit serial number",
            },
        },
        devicesddt: {
            name:  "DDT",
            journal: "Data",
            fields: {
                treshold_p: "Pressure threshold",
                treshold_t: "Temperature threshold",
            },
        },
    },
}

const customEnglishMessages = _.defaultsDeep({}, baseMessages, resourcesParams)
export default customEnglishMessages
